import { render, staticRenderFns } from "./Inset.vue?vue&type=template&id=3c0d25c3&"
import script from "./Inset.vue?vue&type=script&lang=js&"
export * from "./Inset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports